var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg07Contact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_07_contact",
    "data-name": "07 contact",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.491,
    height: 23.144,
    viewBox: "0 0 21.491 23.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_90748",
    "data-name": "Path 90748",
    d: "M22.838,2H6.306A1.653,1.653,0,0,0,4.653,3.653V5.306H3.827a.827.827,0,0,0,0,1.653h.827v5.786H3.827a.827.827,0,0,0,0,1.653h.827v5.786H3.827a.827.827,0,1,0,0,1.653h.827v1.653a1.653,1.653,0,0,0,1.653,1.653H22.838a1.653,1.653,0,0,0,1.653-1.653V3.653A1.653,1.653,0,0,0,22.838,2ZM6.306,23.491V21.838h.827a.827.827,0,1,0,0-1.653H6.306V14.4h.827a.827.827,0,0,0,0-1.653H6.306V6.959h.827a.827.827,0,0,0,0-1.653H6.306V3.653H22.838V23.491Zm8.266-10.332a3.306,3.306,0,1,0-3.306-3.306A3.306,3.306,0,0,0,14.572,13.159Zm0-4.959a1.653,1.653,0,1,1-1.653,1.653A1.653,1.653,0,0,1,14.572,8.2Zm2.48,5.786H12.092a2.48,2.48,0,0,0-2.48,2.48v2.48A1.653,1.653,0,0,0,11.266,20.6h6.613a1.653,1.653,0,0,0,1.653-1.653v-2.48A2.48,2.48,0,0,0,17.052,13.985Zm.827,4.959H11.266v-2.48a.827.827,0,0,1,.827-.827h4.959a.827.827,0,0,1,.827.827Z",
    transform: "translate(-3 -2)",
    fill: "#a6a6a6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg07Contact);
export default __webpack_public_path__ + "static/media/07 contact.ae9bd73a4922f02a928b4a9d0ad3a095.svg";
export { ForwardRef as ReactComponent };